import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device/folder/data";

export class GetFolderRoleDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any;

    constructor(folderId: number, converterType: string) {
        super();
        this.params = { folderId: folderId, converterType: converterType };
    }

    public async execute(): Promise<GetFolderRoleDataResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetFolderRoleDataResData(res);
    }
}

export class GetFolderRoleDataResData extends ApiGenericResponse {
    roleSchema: string = null;
    folderData: string = null;
    roleTitle: string = null;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.roleSchema = response.data.Payload.RoleSchema;
            this.folderData = response.data.Payload.FolderData;
            this.roleTitle = response.data.Payload.RoleTitle;
        }
    }
}
